import * as types from './mutation-types';

export const fetchAsia = ({ commit }, value) => {
  commit(types.ASIAN_COUNTRIES, value);
};

// export const inFirstStep = ({ commit }, value) => {
//   commit(types.FIRST_STEP, value);
// };
